import { IUserAttachment, IUserAttachmentRaw } from './user-attachment.interface';

export type AttachmentAccessMode = 'proxy' | 'signed';

/* eslint-disable @typescript-eslint/naming-convention */
export interface IAgentAttachmentRaw {
  file_id: string;
  object_path: string;
  name: string;
  mime: string;
  access_mode: AttachmentAccessMode;
  url?: string;
  attachment_id?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IAgentAttachment {
  source: 'agent';
  fileId: string;
  objectPath: string;
  name: string;
  mime: string;
  accessMode: AttachmentAccessMode;
  url?: string;
  /** Presente quando o backend registrou o artefato como anexo reenviável. */
  attachmentId?: string;
}

/** Chegam pelo mesmo campo do histórico: só o artefato da AyA tem `file_id`. */
export type IMessageAttachment = IAgentAttachment | IUserAttachment;

export type IMessageAttachmentRaw = IAgentAttachmentRaw | IUserAttachmentRaw;

export const isUserAttachment = (
  attachment: IMessageAttachment
): attachment is IUserAttachment => attachment.source === 'user';

export const isAgentAttachment = (
  attachment: IMessageAttachment
): attachment is IAgentAttachment => attachment.source === 'agent';

/** Reenviar exige o `attachment_id`; a origem do arquivo não importa. */
export type IReusableAttachment = IMessageAttachment & { attachmentId: string };

export const isReusableAttachment = (
  attachment: IMessageAttachment
): attachment is IReusableAttachment => !!attachment.attachmentId;

/** O `attachment_id` identifica o mesmo arquivo nas duas origens. */
export const attachmentKey = (attachment: IMessageAttachment): string =>
  isReusableAttachment(attachment)
    ? `attachment:${attachment.attachmentId}`
    : `agent:${attachment.fileId}`;
